module.exports = __webpack_public_path__ + "img/logo_u1992-0.1c777787.svg";